import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../utils/methods";
import { _post } from "../../utils/network";

import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../components/Form/FormField/FormField.component";
import LoadingButton from '../../components/LoadingButton/LoadingButton.component';

import { sliderConfigs } from './sliderConfig';

const SliderBannersCreate = ({ source, componentType='create' }) => {
	const config = sliderConfigs[source];
	const { t } = useTranslation();
	const { id } = useParams();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t(config.titleKey), link: config.listPath },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [saveButtonIsLoading, setSaveButtonIsLoading] = useState(false);
	const saveSlide = async (event) => {
		event.preventDefault();
		if(saveButtonIsLoading)
			return 0;
		let title = event.target.slideTitle.value.trim();
		if(!typeChecker(title, 'title'))
			return toast.warn(t('title') + ' ' + t('must_have_at_least_3_characters'));
		let image = document.querySelector('#slideImage-upload-list img')?.getAttribute('src')?.trim() || '';
		if(!typeChecker(image, 'image'))
			return toast.warn(t('image') + ' ' + t('cant_be_empty'));
		let link = event.target.slideLink.value.trim();
		if(link && !typeChecker(link, 'link'))
			return toast.warn(t('link_is_not_valid'));
		let is_active = event.target.slideIsActive.checked ? 1 : 0;
		let body = {
			[config.idKey]: id,
			[config.imageKey]: image,
			[config.linkKey]: link,
			[config.titleField]: title,
			other_information: {},
			is_active
		};
		confirmSwal(async () => {
			setSaveButtonIsLoading(true);
			let response = await _post(config.api + '/admin/' + componentType, body);
			setSaveButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [slide, setSlide] = useState({});
	const getSlide = async () => {
		let response = await _post(config.api + '/admin/getOne', { [config.idKey]: id });
		switch(response.code){
			case 200:
				setSlide(response.data[config.itemKey] || {});
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		if(componentType === 'edit')
			getSlide();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t(config.titleKey)}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={saveSlide}>
						<div className="row gx-2">
							<FormField type="image" fieldKey="slideImage" title={t('image')} value={slide?.[config.imageKey]} required tip={config.imageTip} fileMaxSize={2} />
							<FormField type="toggle" fieldKey="slideIsActive" title={t('active')} value={slide?.is_active} required />
							<FormField fieldKey="slideTitle" title={t('title')} value={slide?.[config.titleField]} required />
							<FormField fieldKey="slideLink" title={t('link')} value={slide?.[config.linkKey]} ltr />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name={componentType} isLoading={saveButtonIsLoading}>
								<i className="fa fa-save"></i> {t(componentType === 'create' ? 'create' : 'update')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default SliderBannersCreate;
